import { CSSProperties } from 'react';
import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';

import { Footer, FooterButtons } from '../Footer';

import Dialog from '.';

const ConfirmationDialog = ({
  title,
  confirm,
  onConfirm,
  onCancel,
  showDialog,
  setShowDialog,
  confirmButtonVariant = 'danger',
  maxWidth = '25rem',
  isPending,
  isConfirmDisabled,
  children,
}: {
  title: React.ReactNode;
  confirm: React.ReactNode;
  onConfirm: () => void | false | Promise<void | false>;
  onCancel?: () => void;
  showDialog: boolean;
  setShowDialog?: (show: boolean) => void;
  confirmButtonVariant?: 'primary' | 'danger';
  maxWidth?: CSSProperties['maxWidth'];
  isPending?: boolean;
  isConfirmDisabled?: boolean;
  children: React.ReactNode;
}) => {
  if (!showDialog) {
    return undefined;
  }

  const close = () => {
    if (isPending) {
      return;
    }

    setShowDialog?.(false);
  };

  return (
    <Dialog
      isOpen
      onOpenChange={() => {
        close();
      }}
      title={title}
      style={{ maxWidth }}
    >
      <main>{children}</main>
      <Footer>
        <FooterButtons>
          <Button
            variant="secondary"
            size="medium"
            onPress={() => {
              close();
              onCancel?.();
            }}
            disabled={isPending}
          >
            <Trans id="dialog.close-confirmation.cancel">Cancel</Trans>
          </Button>
          <Button
            variant={confirmButtonVariant}
            size="medium"
            onPress={() => {
              if (isPending || isConfirmDisabled) {
                return;
              }

              Promise.resolve(onConfirm()).then(
                (shouldClose) => {
                  if (shouldClose !== false) {
                    setShowDialog?.(false);
                  }
                },
                () => undefined
              );
            }}
            disabled={isConfirmDisabled}
            isLoading={isPending}
          >
            {confirm}
          </Button>
        </FooterButtons>
      </Footer>
    </Dialog>
  );
};

export default ConfirmationDialog;
